export default function(num) {
  return new Intl.NumberFormat('ru').format(Number(num))
}
